/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 15:55:15
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:10:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentGateway/index.tsx
 */
import {
  Checkbox,
  Input,
  Label,
  Select,
  TextArea,
} from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { paymentGatewayProvider } from '@/src/types/common/paymentGateway';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import _ from 'lodash';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import SplitLine from 'src/components/SplitLine/SplitLine';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { dynamicSuffixOptions } from '../config';
import css from '../css.module.less';
import AdyenItem from './AdyenItem';
import AtomeItem from './AtomeItem';
import QFPayItem from './QFPayItem';
import StripeItem from './StripeItem';

const PaymentGateway = ({
  gatewayProviderIcon,
  gatewayName,
  form,
  disabled,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const [unlockEditable, setUnlockEditable] = useState([]);

  const { gatewayProviderCode } = params;

  const handleResetInput = (key) => {
    form.setFieldsValue({ [key]: '' });
    const unlockEditableCopy = _.cloneDeep(unlockEditable);
    unlockEditableCopy.push(key);
    setUnlockEditable(unlockEditableCopy);
  };

  const tooltipLabel = (
    <div className={css.title}>
      {getI18n('storePayment.paymentEditPage.dynamicSuffix')}{' '}
      <WhiteBackgroundTooltip
        title={
          <TooltipContainer>
            <TooltipTitle>
              {getI18n('storePayment.paymentEditPage.dynamicSuffix')}
            </TooltipTitle>
            <TooltipContent>
              {getI18n('storePayment.paymentEditPage.dynamicSuffixContent')}
            </TooltipContent>
          </TooltipContainer>
        }
        placement='rightTop' //overlayClassName
      >
        <QuestionCircleFilled className={css.icon} />
      </WhiteBackgroundTooltip>
    </div>
  );
  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      rightPart={
        <img
          style={{
            height: 24,
          }}
          src={gatewayProviderIcon?.url}
        />
      }
      title={`${getI18n(
        'storePayment.paymentEditPage.paymentGateway',
      )} - ${gatewayName}`}>
      {disabled ? null : (
        <React.Fragment>
          <Row
            elements={[
              {
                child: (
                  <Form.Item
                    className={css.formItem}
                    name='name'
                    labelCol={{
                      span: 24,
                    }}
                    label={
                      <Label
                        title={`${getI18n(
                          'storePayment.paymentEditPage.paymentGatewayName',
                        )}*`}
                        textLength={100}
                        rightSubTitle={getI18n(
                          'storePayment.paymentEditPage.thisisforinternaluse',
                        )}
                        nameKey='name'
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n(
                            'storePayment.paymentEditPage.paymentGatewayName',
                          ),
                        ),
                      },
                    ]}>
                    <Input
                      size='large'
                      maxLength={100}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
              {
                child: (
                  <Form.Item
                    className={css.formItem}
                    name='remarks'
                    labelCol={{
                      span: 24,
                    }}
                    label={
                      <Label
                        title={getI18n(
                          'storePayment.paymentEditPage.paymentGatewayRemarksOptional',
                        )}
                        textLength={500}
                        rightSubTitle={getI18n(
                          'storePayment.paymentEditPage.thisisforinternaluse',
                        )}
                        nameKey='remarks'
                      />
                    }>
                    <TextArea
                      size='large'
                      autoSize={{ minRows: 1, maxRows: 5 }}
                      maxLength={500}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
            ]}
          />
          <SplitLine className={css.splitLineTop} />
          {gatewayProviderCode == paymentGatewayProvider.STRIPE && (
            <StripeItem
              handleResetInput={handleResetInput}
              unlockEditable={unlockEditable}
              disableEdit={disableEdit}
            />
          )}
          {gatewayProviderCode == paymentGatewayProvider.ADYEN && (
            <AdyenItem
              handleResetInput={handleResetInput}
              unlockEditable={unlockEditable}
              disableEdit={disableEdit}
            />
          )}
          {gatewayProviderCode == paymentGatewayProvider.ATOME && <AtomeItem />}
          {(gatewayProviderCode == paymentGatewayProvider.QFPAY_ALI_HTML5 ||
            gatewayProviderCode == paymentGatewayProvider.QFPAY_WECHAT_HTML5 ||
            gatewayProviderCode ==
              paymentGatewayProvider.QFPAY_WECHAT_MINI) && (
            <QFPayItem
              handleResetInput={handleResetInput}
              unlockEditable={unlockEditable}
              disableEdit={disableEdit}
            />
          )}
          {/* {gatewayProviderCode == paymentGatewayProvider.BANK_TRANSFER && (
        <Form.Item
          name='paymentInstruction'
          labelCol={{
            span: 24,
          }}
          label={<Label title='Payment Instructions*' />}
          rules={[
            { required: true, message: 'Please input Payment Instructions!' },
          ]}>
          <TextArea size='large' maxLength={100} />
        </Form.Item>
      )} */}

          {(gatewayProviderCode == paymentGatewayProvider.STRIPE ||
            gatewayProviderCode == paymentGatewayProvider.ADYEN) && (
            <Form.Item
              noStyle
              name='enablePaymentDescriptor'
              valuePropName='checked'>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {getI18n('storePayment.paymentEditPage.paymentDescriptor')}
                </span>
                <span>
                  (
                  {getI18n('storePayment.paymentEditPage.paymentDescriptorTip')}
                  )
                </span>
              </Checkbox>
            </Form.Item>
          )}
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.enablePaymentDescriptor !==
              curValues.enablePaymentDescriptor
            }>
            {({ getFieldValue }) =>
              getFieldValue('enablePaymentDescriptor') && (
                <Row
                  elements={[
                    {
                      child: (
                        <Form.Item
                          name='staticPrefix'
                          labelCol={{
                            span: 24,
                          }}
                          className={css.staticPrefix}
                          label={
                            <Label
                              title={`${getI18n(
                                'storePayment.paymentEditPage.staticPrefix',
                              )}*`}
                              rightSubTitle={getI18n(
                                'storePayment.paymentEditPage.mustcontainatleast1letter',
                              )}
                              textLength={10}
                              nameKey='staticPrefix'
                            />
                          }
                          rules={[
                            {
                              required: true,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                getI18n(
                                  'storePayment.paymentEditPage.staticPrefix',
                                ),
                              ),
                            },
                            {
                              pattern: /^[0-9a-zA-Z-]{1,}$/,
                              message: getI18n('general.invalidformat'),
                            },
                            {
                              pattern: /^.*[a-z|A-Z].*$/,
                              message: getI18n(
                                'storePayment.paymentEditPage.mustcontainatleast1letter',
                              ),
                            },
                          ]}>
                          <Input
                            size='large'
                            maxLength={10}
                            disabled={disableEdit}
                          />
                        </Form.Item>
                      ),
                    },
                    {
                      child: (
                        <Form.Item
                          name='dynamicSuffix'
                          labelCol={{
                            span: 24,
                          }}
                          label={tooltipLabel}
                          rules={[
                            {
                              required: true,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                tooltipLabel,
                              ),
                            },
                          ]}>
                          <Select
                            size='large'
                            optionsList={dynamicSuffixOptions({ getI18n })}
                            disabled={disableEdit}
                          />
                        </Form.Item>
                      ),
                    },
                  ]}
                />
              )
            }
          </Form.Item>
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};

export default PaymentGateway;
